import { I18n } from '@calendly/i18n';
import { SwitchInput } from '@calendly/ui/components/switch-input';
import { BodyText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import moment from 'moment-timezone';
import React, { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { dateNotationSelector } from 'selectors/current_user';
import { userDateFormatCheckYear } from 'services/time_format';
import { useUpdateAvailabilityUserHolidaySetV4Mutation } from '../api';
import { isSupportedCountry } from './helpers';
const switchLabelCss = "s176kw6w";
const SwitchLabel = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  return <Component ref={ref} {...restProps} className={classNames(switchLabelCss, props.className)} />;
});
const listContainerCss = "l1w86y8s";
const ListContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(listContainerCss, props.className)} />;
});
const holidayContainerIsTabletUpCss = "hfr5e8v";
const holidayContainerCss = "h1bzz7gj";
const HolidayContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTabletUp = useDeviceType('isTabletUp');
  return <Component ref={ref} {...restProps} className={classNames(holidayContainerCss, {
    [holidayContainerIsTabletUpCss]: isTabletUp
  }, props.className)} />;
});
const emptyWrapperCss = "e15hdmj0";
const EmptyWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(emptyWrapperCss, props.className)} />;
});
const Holiday = ({
  holiday: {
    name,
    dateObserved,
    dateActual,
    enabled
  },
  onChange
}) => {
  const dateNotation = useSelector(dateNotationSelector);
  const Wrapper = useDeviceType('isTabletUp') ? React.Fragment : 'div';
  const isObserved = dateObserved !== dateActual;
  const date = userDateFormatCheckYear(moment(dateObserved), dateNotation, 'date_small', 'date_small_with_year');
  const dateText = isObserved ? I18n.t('publisher.availability_settings.section.holidays.next_observed', {
    date
  }) : I18n.t('publisher.availability_settings.section.holidays.next', {
    date
  });
  return <HolidayContainer>
      <Wrapper>
        <BodyText size="medium" weight="semibold">
          {name}
        </BodyText>
        <BodyText size="medium" color="muted">
          {dateText}
        </BodyText>
      </Wrapper>
      <SwitchLabel>
        <SwitchInput aria-label={name} checked={enabled} onChange={onChange} />
      </SwitchLabel>
    </HolidayContainer>;
};
export const HolidayList = ({
  uuid,
  holidays,
  countryCode
}) => {
  const [updateHolidaySet] = useUpdateAvailabilityUserHolidaySetV4Mutation();
  const onToggleHoliday = async holidayKey => updateHolidaySet({
    uuid,
    holidays: holidays.map(holiday => ({
      ...holiday,
      enabled: holiday.key === holidayKey ? !holiday.enabled : holiday.enabled
    })),
    redirect: false
  });
  if (!isSupportedCountry(countryCode)) {
    return <EmptyWrapper>
        <BodyText>
          {I18n.t('publisher.account_settings.holidays.feedback.description')}
        </BodyText>
      </EmptyWrapper>;
  }
  return <ListContainer>
      {holidays.map(holiday => <Holiday key={holiday.key} holiday={holiday} onChange={() => onToggleHoliday(holiday.key)} />)}
    </ListContainer>;
};

require("./holiday_list.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./holiday_list.js");